import React from 'react';
import { Container, List, Icon } from 'semantic-ui-react';
import CardBackground from './CardBackground';
import miniAirwaysImg from '../images/mini_airways.jpg';
import ac27Img from '../images/ac27.jpg';
import caterpillarImg from '../images/caterpillar.jpg';

const PROJECT_BG_MAP = {
  'metro.svg': `${process.env.PUBLIC_URL}/images/metro.svg`,
  'mini_airways.jpg': miniAirwaysImg,
  'ac27.jpg': ac27Img,
  'caterpillar.jpg': caterpillarImg,
};

// Anchor the artwork on its title text (logo first) rather than the composition.
const PROJECT_BG_FOCUS = {
  'ac27.jpg': { x: 0.46, y: 0.16 },
  'mini_airways.jpg': { x: 0.50, y: 0.18 },
};

function ProjectsSection({ projects }) {
  return (
    <Container text textAlign="left">
      {projects.map((project, idx) => {
        const bgUrl = project.bgImage ? PROJECT_BG_MAP[project.bgImage] : null;
        const bgFocus = project.bgImage ? PROJECT_BG_FOCUS[project.bgImage] : undefined;
        return (
        <div
          key={idx}
          className={`agent-window${bgUrl ? ' agent-window--bg-image' : ''}`}
        >
          {/* Title bar */}
          <div className="agent-window__titlebar">
            <div className="agent-window__dots">
              <span className="dot dot--green" style={{ animationDelay: `${idx * 0.5}s` }} />
            </div>
            <Icon name="cube" className="agent-window__icon" />
            <h3 className="agent-window__title">
              {project.url ? (
                <a href={project.url} className="agent-window__link">{project.name}<Icon name="external alternate" className="link-icon" /></a>
              ) : (
                project.name
              )}
            </h3>
          </div>

          {/* Content area */}
          <div className="agent-window__content">
            {bgUrl && <CardBackground src={bgUrl} focus={bgFocus} />}
            <List as="ul">
              {project.items.map((item, i) => (
                <List.Item key={i}>
                  <span className="agent-spinner" style={{ animationDelay: `${i * 0.5}s` }} />
                  <span>{item}</span>
                </List.Item>
              ))}
            </List>
            {project.hasSubItems && project.subItems && (
              project.subItems.map((sub, j) => (
                <div key={j} className="contribution-tier2">
                  <span className="agent-spinner" style={{ animationDelay: `${(project.items.length + j) * 0.5}s` }} />
                  <span className="agent-item-text">
                    <a href={sub.url} className="agent-window__link"><Icon name={sub.icon || 'github'} className="link-icon link-icon--lead" />{sub.name}</a>
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      )})}
    </Container>
  );
}

export default ProjectsSection;
